import { globalConfirmAdvanced } from 'components/Common/Confirm/ConfirmContext';
import { PermissionType } from 'models';
import { RoleType } from './RoleType';


export async function getStandardRights(roleType: RoleType) {
  let permissions = [] as PermissionType[];
  if (roleType == RoleType.AnkomstRegistrerare) {
    permissions = [...permissions, ...[PermissionType.User, PermissionType.AktivaFakturor, PermissionType.SearchInvoices, PermissionType.ChangeInvoiceInformation,
    PermissionType.ChangeKontering,
    PermissionType.BytaAttestkedja,
    PermissionType.Suppliers,
    PermissionType.Attestkedjemall,
    PermissionType.Kontoplan,
    PermissionType.Kostnadsstallen,
    PermissionType.Projekt,
    PermissionType.Valutor,
    ]];
    if ('yes' == await globalConfirmAdvanced("Ska personen också vara med och attestera?", null, ["yes", "no"])) {
      permissions.push(PermissionType.Attestant);
    }
  }
  else if (roleType == RoleType.Attestant) {
    permissions = [...permissions, ...[PermissionType.Attestant, PermissionType.WebUser]];

    if ('yes' == await globalConfirmAdvanced("Skall personen få ändra fakturavärden?\r\n\r\nFakturavärden inkluderar Fakturanr, fakturadatum/förfallodatum, att betala / moms.", "Extra rättigheter", ['yes', 'no'])) {
      permissions.push(PermissionType.ChangeInvoiceInformation);
    }
    if ('yes' == await globalConfirmAdvanced("Skall personen få ändra kontering?", "Extra rättigheter", ['yes', 'no'])) {
      permissions.push(PermissionType.ChangeKontering);
    }

    if ('yes' == await globalConfirmAdvanced("Skall personen få söka bland alla fakturor?\r\n\r\nOm 'Nej' så får personen bara söka bland fakturor där han/hon ligger med i attestkedjan.", "Extra rättigheter", ['yes', 'no'])) {
      permissions.push(PermissionType.SearchInvoices);
    }
  }
  else if (roleType == RoleType.Revisor) {
    permissions = [PermissionType.WebUser, PermissionType.SearchInvoices, PermissionType.AktivaFakturor];
  }

  return permissions;
}
